export default __webpack_public_path__ + "static/media/bookReviews@2x.62212b85.png";